/**
 * Self-initializing PDP custom JavaScript
 * Handles variant swatches, dynamic shipping text, tab functionality and more
 */
(function () {
    // Main initialization function
    function initPDPCustom() {
        console.log("PDP Custom JS initialized");

        // Dynamic shipping text
        updateShippingText();

        // Share button functionality
        initShareButton();

        // Mobile accordion functionality
        initMobileAccordion();

        // Product tabs functionality
        initProductTabs();

        unwrapAccordionBelow1000();

        // Frequently bought together product info
        initFrequentlyBoughtObserver();

        // Variant swatches functionality
        initVariantSwatches();

            const buttons = document.querySelectorAll("button.shopify-payment-button__button, button.shopify-payment-button__more-options");

            buttons.forEach(button => {
                if (!button.hasAttribute("aria-label")) {
                    button.setAttribute("aria-label", "Shopify Payments");
                }
            });
      


    }

    // Dynamic shipping text functionality
    function updateShippingText() {
        let now = new Date();
        let userHour = now.getHours();
        let userMinutes = now.getMinutes();
        let userDay = now.getDay();
        let shippingText = "";

        if (userDay >= 1 && userDay <= 4) {
            if (userHour < 14 || (userHour === 14 && userMinutes === 0)) {
                shippingText = "Order Now - Ships Today";
            } else {
                shippingText = "Order Now - Ships Tomorrow";
            }
        } else {
            shippingText = "Order Now - Ships Monday";
        }

        let shipTextElement = document.querySelector(".dynamic_ship_text");
        if (shipTextElement) {
            shipTextElement.textContent = shippingText;
        }
    }


    function unwrapAccordionBelow1000() {
        if (window.innerWidth > 1000) {
         const accordions = document.querySelectorAll('accordion-disclosure.accordion.mobile-pdp-accordion');

                accordions.forEach(accordion => {
                const details = accordion.querySelector('details.accordion__disclosure');
                if (details) {
                    const summary = details.querySelector('summary');
                    const content = details.querySelector('.accordion__content');

                    if (summary && content) {
                    // Insert the summary and content before the accordion element
                    accordion.parentNode.insertBefore(summary, accordion);
                    accordion.parentNode.insertBefore(content, accordion);
                    }

                    // Finally, remove the entire accordion-disclosure block
                    accordion.remove();
                }
                });
        }
      }


    // Share button functionality
    function initShareButton() {
        console.log("sharecalled")
        const shareIcon = document.querySelector(".share_icon");
        if (shareIcon) {
            shareIcon.addEventListener("click", function () {
                document.querySelector(".share_social_media")?.classList.toggle("hidden");
                setTimeout(() => {
                    if (!document.querySelector(".share_social_media").classList.contains("hidden")) {
                        document.querySelector(".share_social_media").classList.add("hidden");
                    }
                }, 10000);
            });
        }


    }

    // Mobile accordion functionality
    function initMobileAccordion() {
        function updateAccordion() {
            if (window.innerWidth >= 999) {
                document.querySelectorAll('.mobile-pdp-accordion .accordion__disclosure').forEach(el => {
                    el.setAttribute('open', '');
                    el.setAttribute('aria-expanded', 'true');
                });
            }
        }

        updateAccordion();
        window.addEventListener('resize', updateAccordion);
    }

    // Product tabs functionality
    function initProductTabs() {
        const tabProducts = document.querySelectorAll(".tab-product");
        const bottomLine = document.querySelector(".bottom-line");

        if (tabProducts.length) {
            tabProducts.forEach(tab => {
                tab.addEventListener("click", function () {
                    // Remove active class from all tabs and content
                    document.querySelectorAll(".tab-product, .product-tabs").forEach(el => {
                        el.classList.remove("active");
                    });

                    // Add active class to clicked tab
                    this.classList.add("active");

                    // Show corresponding content
                    const tabId = this.getAttribute("tab_id");
                    if (tabId) {
                        const targetTab = document.querySelector(`.${tabId}`);
                        if (targetTab) {
                            targetTab.classList.add("active");
                        }
                    }

                    // Move bottom line if it exists
                    if (bottomLine) {
                        moveBottomLine(this);
                    }
                });
            });

            // Initialize bottom line position
            if (bottomLine && document.querySelector(".tab-product.active")) {
                moveBottomLine(document.querySelector(".tab-product.active"));
            }
        }

        function moveBottomLine(target) {
            bottomLine.style.width = `${target.offsetWidth}px`;
            bottomLine.style.left = `${target.offsetLeft}px`;
        }
    }

    // Frequently bought together product info
    function initFrequentlyBoughtObserver() {
        // Function to create and append product info elements
        function createProductInfo(imageLink, labelText, priceText) {
            // Check if info div already exists
            const existingInfo = imageLink.nextElementSibling?.classList.contains('product-title-label-text');
            if (existingInfo) return;

            // Create wrapper div
            const newDiv = document.createElement('div');
            newDiv.className = 'product-title-label-text';

            // Create label span
            const labelSpan = document.createElement('span');
            labelSpan.textContent = labelText;
            labelSpan.className = 'label-span';

            // Create price span
            const priceSpan = document.createElement('span');
            priceSpan.textContent = priceText;
            priceSpan.className = 'price-span';

            // Append elements
            newDiv.appendChild(labelSpan);
            newDiv.appendChild(priceSpan);

            // Insert after image link
            imageLink.insertAdjacentElement('afterend', newDiv);
        }

        // Function to handle product element updates
        function updateProductElements() {
            const imageLinks = document.querySelectorAll('.cbb-frequently-bought-product-image');
            const productLabels = document.querySelectorAll('.cbb-frequently-bought-selector-label-name');
            const productPrices = document.querySelectorAll('.cbb-frequently-bought-selector-label-regular-price .money');

            imageLinks.forEach((link, index) => {
                if (productLabels[index] && productPrices[index]) {
                    const labelText = productLabels[index].textContent.trim();
                    const priceText = productPrices[index].textContent.trim();
                    createProductInfo(link, labelText, priceText);
                }
            });
        }

        // Function to handle ratings update
        function updateRatings() {
            const targetElements = document.querySelectorAll('.product-title-label-text');
            const productReviews = document.querySelectorAll('.cbb-star-rating-class');

            // Only proceed if we have equal numbers of elements
            if (productReviews.length === targetElements.length) {
                targetElements.forEach((targetElement, index) => {
                    // Remove existing rating if present
                    const existingRating = targetElement.querySelector('.cbb-star-rating-class');
                    if (existingRating) {
                        existingRating.remove();
                    }

                    // Clone and append the corresponding rating
                    if (productReviews[index]) {
                        const clonedReview = productReviews[index].cloneNode(true);
                        targetElement.appendChild(clonedReview);
                    }
                });
            }
        }

        // Create observers
        const productObserver = new MutationObserver((mutations) => {
            let shouldUpdate = false;

            mutations.forEach(mutation => {
                if (mutation.type === 'childList' || mutation.type === 'attributes') {
                    const hasRelevantChanges = Array.from(mutation.target.classList || []).some(className =>
                        className.includes('cbb-frequently-bought')
                    );

                    if (hasRelevantChanges) {
                        shouldUpdate = true;
                    }
                }
            });

            if (shouldUpdate) {
                clearTimeout(productObserver.timeout);
                productObserver.timeout = setTimeout(updateProductElements, 100);
            }
        });

        const ratingObserver = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                if (mutation.type === 'childList') {
                    const hasRatingClass = Array.from(mutation.target.classList || []).some(className =>
                        className.includes('cbb-star-rating-class')
                    );

                    if (hasRatingClass) {
                        setTimeout(updateRatings, 100);
                        break;
                    }
                }
            }
        });

        // Start observers
        updateProductElements();
        productObserver.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true
        });

        ratingObserver.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true
        });
    }

    // Variant swatches functionality
    function initVariantSwatches() {
        // Set up event handlers for variant swatches
        function setupSwatchHandlers() {
            document.querySelectorAll('.first_option_swatch').forEach(swatch => {
                swatch.removeEventListener('click', handleVariantClick);
                swatch.addEventListener('click', handleVariantClick);
            });

            document.querySelectorAll('.variant_swatches').forEach(swatch => {
                swatch.removeEventListener('click', handleSwatchVariantClick);
                swatch.addEventListener('click', handleSwatchVariantClick);
            });

        }

        function handleSwatchVariantClick() {
            setTimeout(() => {
                const descriptionId = this.getAttribute('description_id');
                const boxPack = this.getAttribute('boxes_pack');
                const variantBox = document.querySelector('.variant_boxes');
                const shortDescription = document.querySelector('.variant_short_description');

                // Update boxes pack text
                if (variantBox) {
                    if (boxPack && boxPack.trim().length > 0) {
                        variantBox.textContent = "- " + boxPack;
                    } else {
                        variantBox.textContent = "";
                    }
                }
                if(shortDescription){
                    shortDescription.textContent = window.variantShortDescriptions[descriptionId];
                }
                

                // Update description visibility
                if (descriptionId) {
                    document.querySelectorAll('.product-variant-desc').forEach(desc => {
                        const descId = desc.getAttribute('description_id');
                        desc.classList.toggle('active', descId === descriptionId);
                    });
                } else {
                    // Fallback to checked swatch if no description ID
                    setTimeout(() => {
                        const checkedSwatch = document.querySelector('.variant_swatches[checked]');
                        if (checkedSwatch) {
                            const checkedDescId = checkedSwatch.getAttribute('description_id');
                            if (checkedDescId) {
                                document.querySelectorAll('.product-variant-desc').forEach(desc => {
                                    const descId = desc.getAttribute('description_id');
                                    desc.classList.toggle('active', descId === checkedDescId);
                                });
                            }
                        }
                    }, 100);
                }
            }, 10);

        }

        function handleVariantClick() {
            const kitVariantContainer = document.querySelector('.kit_variant');
            // Handle kit variant container visibility
            if (kitVariantContainer) {
                if (this.classList.contains('hide_kit_variant')) {
                    kitVariantContainer.classList.remove('active');
                    const descriptionId = this.getAttribute('description_id');
                    console.log(descriptionId);
                    // If no description ID and not basic kit variant, click basic kit variant
                    if (!descriptionId && !this.classList.contains('basic-kit-variant')) {
                        const basicKitVariant = document.querySelector('.basic-kit-variant');
                        if (basicKitVariant) {
                            basicKitVariant.click();

                            // Update box pack text after basic kit variant is clicked
                            setTimeout(() => {
                                const checkedSwatch = document.querySelector('.variant_swatches[checked]');
                                const boxPack = checkedSwatch?.getAttribute('boxes_pack')?.trim();
                                const variantBox = document.querySelector('.variant_boxes');
                                const shortDescription = document.querySelector('.variant_short_description');
                                if (variantBox) {
                                    if (boxPack && boxPack.length > 0 && boxPack !== " ") {
                                        variantBox.textContent = "- " + boxPack;
                                    } else {
                                        variantBox.textContent = "";
                                    }
                                }
                                if(shortDescription){
                                    shortDescription.textContent = window.variantShortDescriptions[descriptionId];
                                }
                                // Keep kit variant container hidden
                                const kitVariantContainerLoop = document.querySelector('.kit_variant');
                                if (kitVariantContainerLoop) {
                                    kitVariantContainerLoop.classList.remove('active');
                                }
                            }, 1000);
                        }
                    }
                } else {
                    kitVariantContainer.classList.add('active');
                }
            }

            // Handle image visibility based on alt attribute
            const altName = this.getAttribute('alt_atr');
            let ariaCurrentSet = false;

            document.querySelectorAll('.main-product-image-section').forEach((element) => {
                const isMatch = element.getAttribute('alt_atr') === altName;
                element.classList.toggle('hidden', !isMatch);

                if (isMatch) {
                    setTimeout(() => {
                        element.removeAttribute('hidden');
                    }, 100);

                    if (!ariaCurrentSet && element.classList.contains('carousel-btn')) {
                        element.setAttribute('aria-current', 'true');
                        ariaCurrentSet = true;
                    }
                }
            });
        }

        // Set up initial handlers
        setupSwatchHandlers();

        // Observe for changes in the variant selector container
        const observer = new MutationObserver(() => {
            setupSwatchHandlers();
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    // Auto-initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPDPCustom);
    } else {
        // DOM already loaded
        initPDPCustom();
    }

    // Expose the initialization function globally for quick view
    window.initPDPCustom = initPDPCustom;
})();